const React = require('react');

const IncidentTemplateListItem = require('./incident_template_list_item');
const IncidentTemplateListGroup = require('./incident_template_list_group');

class IncidentTemplateIndex extends React.Component {
  constructor (props) {
    super(props);
    this.pageParam = props.page_param;
  }

  _insertHeader () {
    return (
      <div className="header">
        <h4>Incident Templates</h4>
        <a href={this.props.new_template_url} className="cpt-button size-small style-primary">
          + New Incident Template
        </a>
      </div>
    );
  }

  _buildTemplateItems () {
    const pageParam = this.pageParam;

    return (
      <div>
        { this.props.templates.map((template) => {
          return (
            <div className="table-row" key={template.id}>
              <IncidentTemplateListItem template={template} pageParam={pageParam} />
            </div>
          );
        })}
      </div>
    );
  }

  _buildTemplateGroups () {
    const pageParam = this.pageParam;

    return (
      <div className="template-group-items">
        { this.props.template_groups.map(group => <IncidentTemplateListGroup key={group.param} group={group} pageParam={pageParam} />)}
      </div>
    );
  }

  _tableRowGroupClass () {
    return (`table-row-group ${this.props.template_groups.length ? 'has-template-groups' : ''}`);
  }

  render () {
    if (this.props.templates.length > 0 || this.props.template_groups.length > 0) {
      return (
        <div>
          {this._insertHeader()}
          <div className={this._tableRowGroupClass()}>
            { this.props.templates.length > 0 ? this._buildTemplateItems() : null }
            { this.props.template_groups.length > 0 ? this._buildTemplateGroups() : null }
          </div>
        </div>
      );
    }
    return (
      <div>
        {this._insertHeader()}
        <div className="table-row-group">
          <div className="table-row blank-state">
            <div>
              <strong>Proper preparation prevents poor performance!</strong>
            </div>
            <small>Prepare for downtime before it happens: <a href={this.props.new_template_url} >Create an incident template.</a></small>
          </div>
        </div>
      </div>
    );
  }
}

module.exports = IncidentTemplateIndex;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/manage/incident_templates/incident_template_index.jsx